/**
 * Gestione del carousel.
 * Il sistema inizializza automaticamente come carousel
 * tutti gli elementi inglobati dal selettore "carouselContainer".
 */

const carouselContainer = '.cContainer--TypeCarousel:not(.slick-initialized)';

export default $ => {
  $(carouselContainer).slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    dotsClass: 'eCarousel__Dots',
  });
};



// WEBPACK FOOTER //
// ./assets/js/component/carousel.js